export default "__VITE_ASSET__CRdyP_fO__"